import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { api } from "../lib/api";
import { toast } from "sonner";

// Quiet, unlinked. Owner enters passphrase → backend sets httpOnly cookie
// owner_preview=1 (30 days). All requests carrying that cookie see the full site.
export default function OwnerPreviewPage() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();

  const submit = async (e) => {
    e.preventDefault();
    if (!password || loading) return;
    setLoading(true);
    try {
      await api.post("/owner-preview/verify", { password });
      toast.success("Welcome home.");
      // Small delay so the cookie propagates before the next render.
      setTimeout(() => { window.location.href = "/"; }, 250);
    } catch {
      toast.error("That passphrase didn't match.");
    } finally {
      setLoading(false);
    }
  };

  const logout = async () => {
    try { await api.post("/owner-preview/logout"); } catch { /* ignore */ }
    toast.success("Signed out of preview.");
    setTimeout(() => { window.location.href = "/"; }, 250);
  };

  return (
    <div
      data-testid="owner-preview-page"
      className="min-h-[70vh] flex items-center justify-center px-6"
    >
      <div className="w-full max-w-md">
        <div className="overline text-[var(--gu-muted)] mb-4">Owner preview</div>
        <h1 className="font-display text-4xl lg:text-5xl font-light tracking-tighter leading-[0.95]">
          The keys to the greenhouse.
        </h1>
        <p className="mt-6 text-[var(--gu-muted)] text-sm leading-relaxed">
          Enter your passphrase to bypass the public splash and view the full site.
          Access lasts thirty days on this device.
        </p>
        <form onSubmit={submit} className="mt-10 space-y-6">
          <label className="block">
            <span className="overline text-[var(--gu-muted)] block mb-2">Passphrase</span>
            <input
              type="password"
              required
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              data-testid="owner-password-input"
              className="w-full bg-transparent border-b border-[var(--gu-border)] focus:border-[var(--gu-primary)] outline-none py-2 text-lg font-body transition-colors"
            />
          </label>
          <button
            type="submit"
            disabled={loading}
            data-testid="owner-submit-btn"
            className="w-full bg-[var(--gu-primary)] text-[var(--gu-bg)] py-4 overline hover:bg-[var(--gu-primary)]/90 transition-colors disabled:opacity-50"
          >
            {loading ? "Verifying…" : "Enter"}
          </button>
        </form>
        <button
          type="button"
          onClick={logout}
          data-testid="owner-logout-btn"
          className="mt-8 text-xs text-[var(--gu-muted)] hover:text-[var(--gu-primary)] transition-colors"
        >
          Sign out of preview on this device →
        </button>
        <button
          type="button"
          onClick={() => navigate("/")}
          className="ml-6 mt-8 text-xs text-[var(--gu-muted)] hover:text-[var(--gu-primary)] transition-colors"
        >
          ← Back
        </button>
      </div>
    </div>
  );
}
